'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MessageSmall = require('../../blocks/MessageSmall');

var _MessageSmall2 = _interopRequireDefault(_MessageSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MessageSmall(_ref) {
  var children = _ref.children,
      type = _ref.type;

  return _react2.default.createElement(
    _MessageSmall2.default,
    null,
    _react2.default.createElement(_MessageSmall2.default.Icon, { type: type }),
    _react2.default.createElement(
      _MessageSmall2.default.Text,
      null,
      children
    )
  );
}

MessageSmall.propTypes = {
  children: _propTypes2.default.node.isRequired,
  type: _propTypes2.default.oneOf(['danger', 'info', 'success', 'warning']).isRequired
};

exports.default = MessageSmall;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/MessageSmall/index.js
// module id = 1680
// module chunks = 2